// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

import { UserModel } from '../../auth/shared'

import {
  ChangeEmailPayload,
  ChangePasswordPayload,
  ChangeUserDetailsPayload,
  DeliveryAddressPayload
} from './payload'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface IProfileService {
  changeEmail (payload: ChangeEmailPayload): Promise<UserModel>

  changePassword (payload: ChangePasswordPayload | AnyObject): Promise<void>

  changeUserDetails (payload: ChangeUserDetailsPayload | AnyObject): Promise<UserModel>

  getUserDetails (token: string): Promise<UserModel>

  getUserSubscriptions (token: string): Promise<Agreements>

  removeDeliveryAddress (addressId: number): Promise<void>

  storeDeliveryAddress (payload: DeliveryAddressPayload): Promise<number>

  subscribeNewsletter (isSubscribedNewsletter: boolean): Promise<UserModel>

  updateDeliveryAddress (addressId: number, payload: DeliveryAddressPayload): Promise<number>
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const ProfileServiceType = Symbol.for('IProfileService')

export interface Agreements {
  agreements: {
    email: boolean
    sms: boolean
    push: boolean
    webpush: boolean
    bluetooth: boolean
    rfid: boolean
    wifi: boolean
  }
  email: string
}
